export const CAMPAIGNS_ENABLED =
  import.meta.env.VITE_CAMPAIGNS_ENABLED === undefined
    ? true
    : import.meta.env.VITE_CAMPAIGNS_ENABLED.toLowerCase() === 'true';

/**
 * The pre-export/publish unfilled-slot gate (`BLOCK_FRONTEND_PLAN.md` §8).
 *
 * Off: it is the first thing to inspect campaign content, so it fires on
 * campaigns authored before it existed and blocks a publish that worked the day
 * before. Set to `true` to switch every gate back on at once.
 *
 * A constant rather than an env flag deliberately — an unset Azure variable
 * group passes the macro through unexpanded, which is what silently disabled
 * `CAMPAIGNS_ENABLED`. This cannot be got wrong per environment.
 *
 * Typed `boolean` rather than left to infer `false`, so the call sites read as
 * live branches instead of dead code `no-unnecessary-condition` deletes. The
 * annotation is the point here, not redundancy.
 */
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const CAMPAIGN_VALIDATION_ENABLED: boolean = false;
